<template>
  <material-card color="green" title="Adicionar Nova Fatura" text>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container py-0>
        <v-layout wrap>
          <v-flex xs12 md4>
            <v-autocomplete
              :items="powerplants"
              item-text="name"
              prepend-icon="flash_on"
              label="Planta"
              v-model="power_plant"
              return-object
              :rules="[
                (v) => !!v || 'Selecione a Planta que deseja ver fatura',
              ]"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="competence"
              :rules="competenceRules"
              label="Referente a"
              prepend-icon="schedule"
              class="purple-input"
              :value="current_date"
              mask="##/####"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="consumerunits"
              item-text="installation_number"
              label="Unidade Consumidora"
              v-model="consumer_unit"
              return-object
              :rules="[
                (v) =>
                  !!v || 'Selecione a unidade consumidora que deseja faturar',
              ]"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="total_invoice"
              :rules="amountRules"
              label="Valor a pagar"
              prefix="R$"
              type="number"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-autocomplete
              :items="classes"
              item-text="name"
              item-value="value"
              prepend-icon="flash_on"
              label="Classe"
              v-model="classe"
              :rules="[
                (v) => !!v || 'Selecione a classe da Unidade Consumidora',
              ]"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="balance"
              label="Saldo"
              type="number"
              prefix="kW"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="due_date_utility"
              name="due_date_utility"
              label="Data de Vencimento da Fatura"
              prepend-icon="event"
              type="string"
              mask="##/##/####"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md4 text-xs-right>
            <v-text-field
              v-model="total_amount"
              label="Total Consumido"
              :rules="amountRules"
              type="number"
              prefix="R$"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md4 text-xs-right>
            <v-text-field
              v-model="custo_disp"
              label="Custo de Disponibilidade"
              prefix="R$"
              type="number"
              class="purple-input"
            />
          </v-flex>
          <!-- Energia Elétrica kWh -->
          <v-flex xs12 md3 align-self-baseline>
            <small>Energia Elétrica kWh</small>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="energy_kWh"
              label="Quantidade"
              type="number"
              prefix="kW"
              :rules="amountRules"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="energy_kWh_value"
              label="Tarifa/Preço (R$)"
              type="number"
              prefix="R$"
              :rules="amountRules"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md3 text-xs-right>
            <v-text-field
              v-model="energy"
              :rules="amountRules"
              type="number"
              class="purple-input"
              label="Valor (R$)"
              prefix="R$"
            />
          </v-flex>
          <!-- Fim Energia Eletrica kW -->
          <!-- En comp. kWh s/ ICMS -->
          <v-flex xs12 md3 align-self-baseline>
            <small>En comp. kWh s/ ICMS</small>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="amount_comp_kWh"
              label="Quantidade"
              type="number"
              prefix="kW"
              :rules="amountRules"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="amount_comp_kWh_value"
              label="Tarifa/Preço (R$)"
              type="number"
              prefix="R$"
              :rules="amountRules"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md3 text-xs-right>
            <v-text-field
              v-model="amount_comp"
              :rules="amountRules"
              type="number"
              class="purple-input"
              label="Valor (R$)"
              prefix="R$"
            />
          </v-flex>
          <!-- Fim Energia Eletrica kW -->
          <!-- Créditos Recebidos -->
          <v-flex xs12 md3 align-self-baseline>
            <small>Energia injetada</small>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="amount_kW"
              label="Quantidade"
              type="number"
              prefix="kW"
              :rules="amountRules"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="amount_kWh_value"
              label="Tarifa/Preço (R$)"
              type="number"
              prefix="kW"
              :rules="amountRules"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12 md3 text-xs-right>
            <v-text-field
              v-model="amount"
              :rules="amountRules"
              type="number"
              class="purple-input"
              label="Valor (R$)"
              prefix="R$"
            />
          </v-flex>
          <!-- Fim Créditos Recebidos -->

          <v-flex xs12 text-xs-right>
            <v-btn
              class="mx-0 font-weight-light"
              color="success"
              :loading="loading_save || loading"
              @click.prevent="validate()"
              :disabled="!valid || loading_save || loading"
            >
              <v-icon left dark>add</v-icon>Adicionar Dados
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <cpn-invoice-temp
      :invoice="invoice"
      :newInvoice="newInvoice"
      @setInvoice="setInvoice"
    ></cpn-invoice-temp>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </material-card>
</template>

<script>
// import { eventBus } from '../../main'
import InvoiceTemp from "./invoiceTemp";
import moment from "moment";
// import { GET_BILLING_BY_USER, SET_BILLING } from "../../graphql/billing"
import { GET_POWERPLANTCOMBO } from "../../graphql/powerplants";
import { getTotalBilling, setBilling } from "../../services/billing";
import { updateUser, getUser } from "../../services/users";
import { mapState } from "vuex";

export default {
  props: ["consumerunits", "customer_id"],
  data: function () {
    return {
      consumer_unit: "", // Numero da unidade consumidora que está sendo faturada
      valid: false,
      loading: false,
      loading_save: false,
      competence: moment(new Date().toISOString().substr(0, 10)).format(
        "MMYYYY",
      ),
      date: new Date().toISOString().substr(0, 7),
      amount: 0, // Créditos recebidos em Reais (R$).
      custo_disp: 0, // Custo de Disponibilidade: É gerado quando o consumo do membro no mês é menor que os créditos injetados - custo minimo de pagamento da conta.
      amountRules: [
        (v) => !!v || "Por favor, esse dado é obrigatório.",
        (v) =>
          v.length > 0 || "Por favor, os valores devem ser maiores que zero.",
      ],
      competenceRules: [
        (v) => !!v || "Por favor, preencher a competência da fatura.",
        (v) =>
          !(v.substr(2, 4) < 2019) ||
          "Por favor, o ano deve ser valido. " + v.substr(2, 4),
        (v) =>
          !(v.substr(0, 2) > 12) ||
          "Por favor, o mes deve ser valido. " + v.substr(0, 2),
      ],
      energy: 0, // Energia eletrica consumida pelo membro em R$
      energy_kWh: 0, // Energia eletrica consumida pelo membro em kWh
      energy_kWh_value: 0, // Tarifa/Preço por kWh consumida pelo membro não injetados
      amount_kW: 0, // Créditos recebidos em kW.
      amount_kWh_value: 0, // Tarifa/Preço por kWh
      amount_comp: 0, // Creditos compensados sem ICMS
      amount_comp_kWh: 0, // Creditos compensados em kWh
      amount_comp_kWh_value: 0, // Tarifa/Preço por kWh compensados
      tarifa: 0, // Valor correto de energia injetada, considerando o valor unitário do kWh cheio
      discount: 0, // Economia gerada para o Cliente em Reais (R$). Calcula posteriormente conforme custo de disponibilidade e referral_balance
      total: 0, // Valor da fatura do Cliente para a Enercred em R$
      total_amount: 0,
      total_invoice: 0, // Valor que o membro deve pagar para a concessionária.
      total_utility_company: 0,
      installation_number: "",
      due_date_utility: "", // Data de vencimento do boleto
      power_plant_id: "", // Planta ao qual a fatura esta vinculada
      balance: 0, // Saldo: É gerado quando o consumo do membro é menor do que os créditos injetados.
      classe: "", // Custo de Custo de Disponibilidade pela classe
      invoice: {
        competence: "",
        power_plant_id: "",
        amount: 0,
        amount_kW: 0,
        total: 0,
        discount: 0,
        consumerunits: [],
        total_invoice: 0,
        custo_disp: 0,
        total_utility_company: 0,
        balance: 0,
      },
      powerplants: [],
      power_plant: {},
      consumerUnitsRules: [
        (v) => !!v || "Por favor, informe a unidade consumidora.",
      ],
      newInvoice: {},
      newInvoices: [],
      current_date: new Date(),
      color: null,
      colors: ["purple", "info", "success", "warning", "error"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
      classes: [
        { name: "Monofásico", value: 30 },
        { name: "Bifásico", value: 50 },
        { name: "Trifásico", value: 100 },
      ],
      new_balance: 0,
    };
  },
  components: {
    cpnInvoiceTemp: InvoiceTemp,
  },
  apollo: {
    powerplants: {
      query: GET_POWERPLANTCOMBO,
      // Optional result hook
      result({ data, loading }) {
        this.power_plants = data.powerplants;
        this.loading = loading;
      },
      // Error handling
      error(error) {
        console.error("We've got an error!", error);
      },
    },
  },
  computed: {
    ...mapState(["user"]),
    filteredPowerPlants() {
      if (this.user.group === "admin") {
        return this.power_plants;
      }

      var PowerPlantArray = [];
      this.power_plants.filter((power_plant) => {
        return this.user.power_plants.filter((power_plant2) => {
          if (power_plant2.power_plant_id === power_plant.power_plant_id) {
            PowerPlantArray.push(power_plant);
          }
        });
      });

      return PowerPlantArray;
    },
  },
  methods: {
    onDone: function () {
      this.refetch();
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const mes = this.competence.substr(0, 2);
        const ano = this.competence.substr(2, 4);
        const newCompetence = ano + "-" + mes;

        const billing_config = await getTotalBilling(
          this.power_plant.power_plant_id,
          newCompetence,
        );
        if (!billing_config.data()) {
          this.snack(
            "Erro, não foi encontrado a configuração para essa planta e competencia",
            "error",
            "top",
          );
          this.loading = false;
          return;
        }
        // console.log('billing_config: ', billing_config.data())
        const user = await getUser(this.customer_id);
        if (!user.data()) {
          this.snack(
            "Erro ao recuperar dados do membro selecionado.",
            "error",
            "top",
          );
          this.loading = false;
          return;
        }

        // Pega a competencia da conta
        this.invoice.competence = newCompetence;
        this.invoice.customer_id = this.customer_id;
        this.invoice.consumer_unit = this.consumer_unit.installation_number;
        // Valor que o membro pagará para a concessionária
        this.invoice.total_invoice = this.total_invoice * 1;

        // Total Consumido pelo membro
        this.invoice.total_amount = this.total_amount * 1;

        // Créditos recebidos pelo membro
        this.invoice.amount = this.amount * 1;

        // Créditos em KW recebidos pelo membro
        this.invoice.amount_kW = this.amount_kW * 1;

        // // Tarifa/Preço por kWh
        this.invoice.amount_kWh_value = this.amount_kWh_value * 1;

        // Creditos compensados sem ICMS
        this.invoice.amount_comp = this.amount_comp * 1;

        // Creditos compensados em kwh
        this.invoice.amount_comp_kWh = this.amount_comp_kWh * 1;

        // Tarifa/Preço por kWh compensados
        this.invoice.amount_comp_kWh_value = this.amount_comp_kWh_value * 1;

        // Energia eletrica consumida pelo membro em R$
        this.invoice.energy = Number(this.energy);

        // Energia eletrica consumida pelo membro em kWh
        this.invoice.energy_kWh = Number(this.energy_kWh);

        // Tarifa/Preço por kWh consumida pelo membro não injetados
        this.invoice.energy_kWh_value = Number(this.energy_kWh_value);

        this.invoice.classe = this.classe;

        // Valor da mensalidade Enercred do Cliente
        this.invoice.total = this.amount * 0.8 * 1;

        // Valor da mensalidade Enercred do Cliente
        this.invoice.balance = this.balance * 1;

        if (typeof this.consumer_unit.percentage_discount === "undefined") {
          this.snack(
            "Erro, não foi identificado percentual de desconto do usuário",
            "error",
            "top",
          );
          this.loading = false;
          console.error(
            "Erro, não foi identificado percentual de desconto do usuário",
          );
          return;
        } else {
          this.invoice.percentage_discount =
            this.consumer_unit.percentage_discount;
        }
        const new_percentage = this.consumer_unit.percentage_discount / 100;

        this.invoice.power_plant_id = this.power_plant.power_plant_id;

        this.invoice.status = "pending";

        // this.invoice.consumer_units[0].total = this.invoice.consumer_units[0].total * (1 - new_percentage) // Valor da fatura do Cliente sem referral e sem custo de disponibilidade.
        // invoice.total = invoice.total * (1 - new_percentage) // Valor da fatura do Cliente.

        // Calcula o valor real da fatura do membro (kWh unitario x quantidade de creditos injetados
        if (this.invoice.energy_kWh_value === 0) {
          // invoice.energy_kWh = invoice.amount_kW
          this.energy_kWh_value = this.invoice.energy / this.invoice.energy_kWh;
          this.invoice.energy_kWh_value = this.energy_kWh_value;
          this.energy_amount = this.invoice.amount_kW * this.energy_kWh_value;
        } else {
          this.energy_amount =
            this.invoice.amount_kW * this.invoice.energy_kWh_value;
        }
        this.invoice.tarifa = this.energy_amount;

        this.invoice.total = this.energy_amount * (1 - new_percentage); // Valor da fatura do Cliente.

        // Calcular quanto o membro pagaria para a Concessionário se não houvesse Enercred
        if (Number(this.custo_disp) > 0) {
          if (this.invoice.energy_kWh > this.invoice.classe) {
            this.invoice.total_utility_company = this.invoice.energy;
          } else {
            this.invoice.total_utility_company = this.invoice.total_invoice;
          }
        } else {
          this.invoice.total_utility_company =
            this.invoice.total_invoice +
            this.invoice.energy_kWh_value * this.invoice.amount_kW -
            (this.invoice.amount_comp - this.invoice.amount);
        }

        // Calcula o desconto que o membro possui
        if (billing_config.data().cobraCustoDisp) {
          // Grava a economia real do membro
          // invoice.discount = (this.energy_amount * new_percentage) - invoice.custo_disp
          if (this.invoice.amount_kW >= this.invoice.energy_kWh) {
            this.invoice.discount =
              this.energy_amount * new_percentage - this.invoice.custo_disp;
          } else {
            this.invoice.discount =
              this.invoice.total_utility_company -
              (this.invoice.total_invoice + this.invoice.total);
          }
        } else {
          this.invoice.discount = this.energy_amount * new_percentage;
          // invoice.total = invoice.total - invoice.custo_disp
          if (this.invoice.custo_disp > 0)
            this.invoice.total =
              this.invoice.energy -
              this.invoice.total_invoice -
              this.invoice.discount;
        }

        const user_referral_balance = user.data().referral_balance || 0;
        if (user_referral_balance > 0) {
          if (user_referral_balance > this.invoice.total) {
            this.new_balance = user_referral_balance - this.invoice.total;
            this.invoice.referral_balance =
              user_referral_balance - this.new_balance;
            this.invoice.total = 0;
          } else {
            this.invoice.total = this.invoice.total - user_referral_balance;
            this.invoice.referral_balance = user_referral_balance;
            this.new_balance = 0;
          }
        }
        let day = this.due_date_utility.split("/")[0];
        let due_date_utility = "";
        if (day.length > 2) {
          // console.log(day.length)
          day = this.due_date_utility.substring(0, 2);
          const mounth = this.due_date_utility.substring(2, 4);
          const year = this.due_date_utility.substring(4, 10);
          due_date_utility = year + "-" + mounth + "-" + day;
        } else {
          const mounth = this.due_date_utility.split("/")[1];
          const year = this.due_date_utility.split("/")[2];
          due_date_utility = year + "-" + mounth + "-" + day;
        }
        const date_venc = new Date(due_date_utility);

        let invoice_unit = {
          consumer_unit: this.consumer_unit.installation_number,
          amount: this.amount * 1,
          amount_kW: this.amount_kW * 1,
          total: this.amount * 1 * 0.8,
          total_invoice: this.total_invoice * 1,
          total_amount: this.total_amount * 1,
          custo_disp: this.custo_disp * 1,
          discount: this.amount * 1 - this.amount * 0.8 - this.custo_disp * 1,
          total_utility_company: this.invoice.total_utility_company,
          due_date_utility: date_venc,
          balance: this.balance * 1,
        };

        this.invoice.due_date_utility = date_venc;
        // console.log('invoice_unit: ', invoice_unit)
        this.newInvoices.push(invoice_unit);
        this.invoice.consumerunits.push(invoice_unit);
        this.amount = 0;
        this.amount_kW = 0;
        this.total_amount = 0;
        this.total_invoice = 0;
        this.custo_disp = 0;
        this.total_utility_company = 0;
        localStorage.setItem("invoice_tmp", JSON.stringify(this.invoice));
        this.loading = false;
      }
    },
    setInvoice(invoice) {
      this.loading_save = true;
      setBilling(invoice)
        .then(() => {
          updateUser(this.customer_id, { referral_balance: this.new_balance });
          // console.log(`Fatura adicionada billing/${billing.id}`)
          this.snack("Fatura adicionada com sucesso!", "success", "top");
          this.loading_save = false;
          // resolve(invoice)
        })
        .catch((error) => {
          // console.log(`Erro ao adicionar fatura billing/${billingdata.power_plant_id}/${billingdata.competence}/${billingdata.customer_id} `, error)
          console.error(error);
          this.snack(error.message, "error", "top");
          this.loading_save = false;
          // reject(error)
        });
      // if (invoice) {
      //   this.$apollo
      //     .mutate({
      //       // Query
      //       mutation: SET_BILLING,
      //       // Parameters
      //       variables: {
      //         customer_id: this.customer_id,
      //         competence: invoice.competence,
      //         power_plant_id: invoice.power_plant_id,
      //         status: "pending",
      //         amount: invoice.amount,
      //         amount_kW: invoice.amount_kW,
      //         discount: invoice.discount,
      //         total: invoice.total,
      //         total_invoice: invoice.total_invoice,
      //         total_utility_company: invoice.total_utility_company,
      //         custo_disp: invoice.custo_disp,
      //         balance: invoice.balance,
      //         due_date_utility: invoice.due_date_utility,
      //         consumer_units: invoice.consumerunits
      //       },
      //       update: (store, { data: { createBilling } }) => {
      //         const data = store.readQuery({
      //           query: GET_BILLING_BY_USER,
      //           variables: {
      //             customer_id: this.customer_id
      //           }
      //         })
      //         data.billing.unshift(createBilling)
      //         store.writeQuery({ query: GET_BILLING_BY_USER, data })
      //       }
      //     })
      //     .then(() => {
      //       // this.loading = res.loading
      //       this.snack("Fatura adicionada com sucesso!", "success", "top")
      //       // this.refetch()
      //     })
      //     .catch(error => {
      //       this.loading = false
      //       this.snack(error.message, "error", "top")
      //     })
      // }
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>
